/** Registro dos prints reais da LP /magistral (CDN + dimensões naturais). */
import app_atencao from "./app-atencao.png.asset.json";
import app_colaboradores from "./app-colaboradores.png.asset.json";
import app_dashboard from "./app-dashboard.png.asset.json";
import app_desempenho from "./app-desempenho.png.asset.json";
import base_cliente from "./base-cliente.png.asset.json";
import base_formula from "./base-formula.png.asset.json";
import base_historico from "./base-historico.png.asset.json";
import campanhas_fc from "./campanhas-fc.png.asset.json";
import dash_clientes from "./dash-clientes.png.asset.json";
import hero_vitalis from "./hero-vitalis.png.asset.json";
import dash_quem_chamar from "./dash-quem-chamar.png.asset.json";
import dash_resumo from "./dash-resumo.png.asset.json";
import orc_consulta from "./orc-consulta.png.asset.json";
import orc_peca from "./orc-peca.png.asset.json";
import pag_lista from "./pag-lista.png.asset.json";
import pag_painel from "./pag-painel.png.asset.json";
import pcp_detalhe from "./pcp-detalhe.png.asset.json";
import pcp_lista from "./pcp-lista.png.asset.json";
import rank_classificacao from "./rank-classificacao.png.asset.json";
import rank_painel from "./rank-painel.png.asset.json";

import { MAGISTRAL_WEBP } from "./webp";

export type MagistralImage = { url: string; width: number; height: number };

export const MAGISTRAL_IMAGES: Record<string, MagistralImage> = {
  "app-atencao": { url: app_atencao.url, width: 589, height: 1280 },
  "app-colaboradores": { url: app_colaboradores.url, width: 589, height: 1280 },
  "app-dashboard": { url: app_dashboard.url, width: 589, height: 1280 },
  "app-desempenho": { url: app_desempenho.url, width: 589, height: 1280 },
  "base-cliente": { url: base_cliente.url, width: 1132, height: 940 },
  "base-formula": { url: base_formula.url, width: 1106, height: 944 },
  "base-historico": { url: base_historico.url, width: 1100, height: 943 },
  "campanhas-fc": { url: campanhas_fc.url, width: 1078, height: 337 },
  "hero-vitalis": { url: hero_vitalis.url, width: 589, height: 1377 },
  "dash-clientes": { url: dash_clientes.url, width: 1099, height: 943 },
  "dash-quem-chamar": { url: dash_quem_chamar.url, width: 1085, height: 936 },
  "dash-resumo": { url: dash_resumo.url, width: 1089, height: 937 },
  "orc-consulta": { url: orc_consulta.url, width: 1079, height: 945 },
  "orc-peca": { url: orc_peca.url, width: 860, height: 1331 },
  "pag-lista": { url: pag_lista.url, width: 1085, height: 945 },
  "pag-painel": { url: pag_painel.url, width: 1075, height: 939 },
  "pcp-detalhe": { url: pcp_detalhe.url, width: 1092, height: 937 },
  "pcp-lista": { url: pcp_lista.url, width: 1111, height: 940 },
  "rank-classificacao": { url: rank_classificacao.url, width: 1121, height: 940 },
  "rank-painel": { url: rank_painel.url, width: 1102, height: 932 },
};


/** srcset WebP do print (fallback: string vazia quando não houver variantes). */
export function magistralWebpSrcSet(name: string): string {
  const variants = MAGISTRAL_WEBP[name];
  if (!variants?.length) return "";
  return variants.map((v) => `${v.url} ${v.width}w`).join(", ");
}

/** Menor variante WebP: usada como src principal e no preload do hero. */
export function magistralWebpUrl(name: string): string | undefined {
  const variants = MAGISTRAL_WEBP[name];
  if (!variants?.length) return undefined;
  return variants[variants.length - 1]?.url;
}
